import styled from 'styled-components'

interface ProgressProps {
  size?: 'mini' | 'small' | 'large' | 'medium'
  percentage_fill?: string
}

export const ProgressGraph = styled.div<ProgressProps>`
  min-width: ${(props) => (props.size === 'mini' ? '50px' : '100px')};
  min-height: ${(props) => (props.size === 'mini' ? '50px' : '100px')};
  margin-right: 1rem;

  display: flex;
  align-items: center;
  justify-content: center;

  .circular-chart {
    display: block;
    margin: 5px auto;
    max-width: 80%;
    max-height: 250px;
  }

  .circle-bg {
    fill: none;
    stroke: ${({ theme }) => `rgba(${theme.green[100]}, 0.2)`};
    stroke-width: 2;
  }

  .circle {
    fill: none;
    stroke-width: 1.2;
    stroke-linecap: round;
    animation: progress 4s ease-out forwards;
  }

  @keyframes progress {
    0% {
      stroke-dasharray: 0 100;
    }
  }
  .circular-chart .circle {
    stroke: ${({ theme }) => `rgb(${theme.greenProgress.base})`};
  }

  .percentage {
    fill: ${(props) =>
      props.percentage_fill ? props.percentage_fill : `rgb(${props.theme.grayscale[100]})`};
    font-family: 'Montserrat', sans-serif;
    font-size: 0.5rem;
    font-weight: 700;
    text-anchor: middle;
  }
`
